/* Confetti burst — tiny pure-CSS-ish component. Renders once on mount
 * and cleans itself up after the animation finishes. No dependency.
 * Zero cost when not mounted.
 */
import { useEffect, useMemo, useState } from "react";

export default function ConfettiBurst({ count = 32, duration = 1400 }) {
    const [gone, setGone] = useState(false);
    const pieces = useMemo(() => (
        Array.from({ length: count }, (_, i) => ({
            id: i,
            x: Math.random() * 100,          // vw
            delay: Math.random() * 220,
            hue: Math.floor(Math.random() * 360),
            rot: Math.floor(Math.random() * 360),
            size: 6 + Math.random() * 8,
        }))
    ), [count]);
    useEffect(() => {
        const t = setTimeout(() => setGone(true), duration + 240);
        return () => clearTimeout(t);
    }, [duration]);
    if (gone) return null;
    return (
        <div className="fixed inset-0 pointer-events-none z-[80]" aria-hidden="true" data-testid="confetti-burst">
            {pieces.map((p) => (
                <span
                    key={p.id}
                    className="absolute -top-4"
                    style={{
                        left: `${p.x}vw`,
                        width: `${p.size}px`,
                        height: `${p.size * 1.4}px`,
                        background: `hsl(${p.hue}, 90%, 60%)`,
                        transform: `rotate(${p.rot}deg)`,
                        animation: `fx-confetti-fall ${duration}ms cubic-bezier(0.22, 0.65, 0.4, 1) ${p.delay}ms forwards`,
                        borderRadius: "2px",
                    }}
                />
            ))}
        </div>
    );
}
